<div class="search-navigation">
  @if(hasPreviousArtifact) {
    <div class="search-navigation__back">
      <button
        mat-button
        class="search-navigation__button"
        color="primary"
        (click)="onPreviousArtifactClick()"
        [disabled]="disabled"
      >
        <mat-icon>
          arrow_left
        </mat-icon>

        {{ previousArtifactName }}
      </button>
    </div>
  }
  @if (searchContext && !hasPreviousArtifact) {
    <div class="search-navigation__navigation">
      @if (backClick.observed) {
        <button
          mat-icon-button
          class="search-navigation__icon-button density--2"
          (click)="onBackClick()"
          [disabled]="!canNavigateBack || disabled"
        >
          <mat-icon matButtonIcon>
            chevron_left
          </mat-icon>
        </button>
      }

      <div class="search-navigation__page-info">
        {{ 'TRANS__OBJECT_PAGE_V2__HEADER__SEARCH_CONTEXT_RESULTS' | translate: { x: searchContext.findResultIndex(artifactId) >= 0 ? searchContext.findResultIndex(artifactId) + 1 : 1, y: searchContext.searchResults.length} }} <span>{{ 'TRANS__OBJECT_PAGE_V2__HEADER__SEARCH_CONTEXT_SELECTED_PAGE' | translate }}</span>
      </div>

      @if(forwardClick.observed) {
        <button
          mat-icon-button
          class="search-navigation__icon-button density--2"
          (click)="onForwardClick()"
          [disabled]="!canNavigateForward || disabled"
        >
          <mat-icon matButtonIcon>
            chevron_right
          </mat-icon>
        </button>
      }
    </div>
  }

  <div class="search-navigation__close">
    @if (!searchContext && !hasPreviousArtifact) {
      <button
        mat-icon-button
        class="search-navigation__mobile-close"
        [attr.aria-label]="'TRANS__OBJECT_PAGE_V2__HEADER__CLOSE' | translate"
        (click)="onCloseClick()"
        [disabled]="disabled"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
    <button
      mat-button
      class="search-navigation__button"
      [class.search-navigation__desktop-close]="!searchContext && !hasPreviousArtifact"
      color="primary"
      (click)="onCloseClick()"
      [disabled]="disabled"
    >
      <mat-icon>
        @if (searchContext) {
          search
        }
        @else {
          close
        }
      </mat-icon>
      @if (searchContext) {
        {{ 'TRANS__OBJECT_PAGE_V2__HEADER__BACK_TO_SEARCH' | translate }} ({{'TRANS__OBJECT_PAGE_V2__HEADER__SEARCH_CONTEXT_RESULTS__HITS_COUNT' | translate: { y: searchContext.resultSize} }})
      }
      @else {
        {{ 'TRANS__OBJECT_PAGE_V2__HEADER__CLOSE' | translate }}
      }
    </button>
  </div>
</div>
